import React, {useEffect, useState, useRef} from "react";
import {Auth} from "@aws-amplify/auth";
import ReplyMessage from "./ReplyMessage";
import { Card, Row, Col, Overlay, Tooltip, OverlayTrigger, Button, Image, Badge, Table } from 'react-bootstrap';
import DOMPurify from "dompurify";
import moment from "moment";
import { BsReplyFill, BsCaretDownFill, BsInfoCircleFill, BsQuestionCircleFill } from "react-icons/bs";
import {TbAlertTriangle, TbAnalyze} from "react-icons/tb"
import {BiMinusCircle} from "react-icons/bi"
import userImage from "../assets/user.png"
import { isIgnoreTestForDisplay, isNegativeResult, isPositiveResult, isOther, isInconclusive, TEST_CATEGORIES } from "../util/resultUtils";
import ResultDetails from "./KitDetails/ResultDetails";
import ApiService from "../ApiService";
import { getSenderName, getSenderInitial } from "../util/common";
import { getUserRoles, ROLE_NAME } from "../util/authUtil";

const MessageTestDetail = (props) => {
    const {messageUUID, message, sentMessage, displayOnlyTestResults} = props;
    const [customerId, setCustomerId] = useState("");
    const [replyMessageComponent, setReplyMessageComponent] = useState(null);
    const data = props.message.testResult.results;
    const [show, setShow] = useState(false);
    const target = useRef(null);
    const [patientDetail, setPatientDetail] = useState(null)

    useEffect(() => {
        const userSubId =
          message?.fromField === "PATIENT"
            ? message?.fromId
            : message?.toField === "PATIENT"
            ? message?.toUsers.find(user => user.addresseeType === "PATIENT")?.userId
            : message?.toIds[0];
    
        if (userSubId && message?.messageType !== "BELUGA") {
          ApiService.getPatientDetailsBySubId(userSubId)
            .then(res => {
              if (res?.data) setPatientDetail(res.data);
            })
            .catch(err => {
              console.error(err);
            });
        }
    }, [message]);
    
      const [isSuperAdmin, setIsSuperAdmin] = useState(false);
    
      useEffect(() => {
        getUserRoles().then(roles => {
            setIsSuperAdmin(roles.includes(ROLE_NAME.SUPER_ADMIN));
        });
      }, [])

    function reply() {
        setReplyMessageComponent(<ReplyMessage messageUUID={messageUUID}/>);
    }

    if (!customerId) {
        Auth.currentSession().then(sess => {
            setCustomerId(sess.getIdToken().getJwtToken());
        }).catch(err => {
            console.error(err);
        });
    }

    useEffect(() => {
        if (document.getElementById("ackcheckbox") && message.readDateTime) {
            document.getElementById("ackcheckbox").checked = true
            document.getElementById("ackcheckbox").disabled = true
        } else if (document.getElementById("ackcheckbox")) {
            document.getElementById("ackcheckbox").checked = false
            document.getElementById("ackcheckbox").disabled = false
        }
    }, [message]);

    if (displayOnlyTestResults === true) {
        return (
            <Row className="TestResult">
                    <ResultDetails
                        testResults={props.message.testResult.results}
                        displayOnlyTestResults={true}
                        />
            </Row>
        )
    }

    if (!message) {
        return (<div className="open_message">Fetching Message</div>);
    } else {
        return (
            <div className="divRow">
                <Card.Title as={Row} className="msgSubject">
                    <Col>SUB: {message.subject}</Col>
                    <Col className="titleInfo">{message.ccOnly === true? 
                        <OverlayTrigger
                                placement="bottom"
                                overlay={
                                <Tooltip>
                                    <Row className="tooltipCard">
                                        You are in CC with this message thread.
                                    </Row>
                                </Tooltip>
                                }
                            >
                                <Button variant="warning" size="sm" id="ccToBtn">CC <BsInfoCircleFill/></Button>
                            </OverlayTrigger> : <OverlayTrigger
                                placement="bottom"
                                overlay={
                                <Tooltip>
                                    <Row className="tooltipCard">
                                        This message is sent to you. {message?.toNames?.toString()}
                                    </Row>
                                </Tooltip>
                                }
                            >
                                <Button variant="warning" size="sm" id="ccToBtn">To <BsInfoCircleFill/></Button>
                        </OverlayTrigger>}
                    </Col>
                </Card.Title>
                <Card.Text>
                    <Row className="msgFromUser">
                        <div className="msgFromUserBig">
                            <OverlayTrigger
                                placement="bottom"
                                overlay={
                                <Tooltip className="profileTooltip">
                                    <Row className="profileCard">
                                        <Col md={3}>
                                            <div>
                                            {
                                                <Image roundedCircle className="profile-pic" alt={"TBD user "} src={userImage}/>
                                            }
                                            </div>
                                        </Col>
                                        <Col md={8}>
                                            <div className="userName">
                                                {getSenderName(message, patientDetail)}
                                            </div>
                                            <div>
                                                {message?.fromUser?.phoneNumber}
                                            </div>
                                            <div>
                                                {message?.fromUser?.email}
                                            </div>
                                        </Col>
                                    </Row> 
                                </Tooltip>
                                }
                            >
                            <div>{getSenderInitial(message, patientDetail)}</div>
                            </OverlayTrigger>
                        </div>
                        <Col md={7}>
                            <p className="msgFromUserFull">{getSenderName(message, patientDetail)}</p>
                            <p className="msgToUser">To: {message?.toNames?.toString().substring(0, 50)}... <span ref={target} onClick={() => setShow(!show)}> <BsCaretDownFill/></span></p>
                            <p className="msgToUser">CC: {message?.ccToGroupNames?.toString().substring(0, 50)}</p>
                        </Col>
                        <Col className="text-right" md={4}>
                            {
                            (sentMessage !== true && message.fromID !== null) || message.reply === true || isSuperAdmin ?
                                <p className="mssReplySmall" onClick={reply}>Reply <BsReplyFill/></p>
                                : <OverlayTrigger
                                    placement="left"
                                    overlay={
                                    <Tooltip>
                                        <Row className="tooltipCard">
                                            Correct state license is missing. You have Read Only access to this message thread.
                                        </Row>
                                    </Tooltip>
                                    }
                                >
                                    <Button variant="secondary" size="sm" id="readOnlyBtn">Read only <BsInfoCircleFill/></Button>
                                </OverlayTrigger>
                            }
                            <p className="msgToUser">{moment(message.createdDateTime).format("ddd MMM D, YYYY LT")}</p>
                        </Col>
                    </Row>
                    <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message.testResult.externalNotes) }}
                        className="message_text">
                    </div>
                    <hr></hr>
                    {replyMessageComponent}
                    <Row className="TestResult">
                    <ResultDetails
                        testResults={props.message.testResult.results}
                        displayOnlyTestResults={true}
                        />
                    </Row>
                </Card.Text>
                <hr></hr>
                <Overlay target={target.current} show={show} placement="right">
                    {(props) => (
                    <Tooltip {...props}>
                        <Row className="overlayCard">
                            <Table size="sm" className="tooltipTable">
                                <tbody>
                                    <tr className="tabRow">
                                        <td className="colText">
                                            From:
                                        </td>
                                        <td className="colText">
                                        {getSenderName(message, patientDetail)}
                                        </td>
                                    </tr>
                                    <tr className="tabRow">
                                        <td className="colText">
                                            To:
                                        </td>
                                        <td className="colText">
                                            {message?.toNames?.toString()}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Row>
                    </Tooltip>
                    )}
                </Overlay>
            </div>
        )
    }
};

export default MessageTestDetail;